import { ExperienceSection } from '@components/sections/ExperienceSection'

import { config } from './config'
import { AccessContentWrapper } from './styles'

export function HallMarksSection() {
  return (
    <AccessContentWrapper>
      <ExperienceSection {...config} hover />
    </AccessContentWrapper>
  )
}
